// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auth-pages__Logout__container__2rR-3 {\n  -ms-flex-align: center;\n      align-items: center;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n\n.auth-pages__Logout__blurb__3vomt {\n  color: #656568;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  font-size: 1.3rem;\n  margin: 1.8rem 0 0;\n}\n\n.auth-pages__Logout__link__2pijF {\n  color: #007aff;\n  cursor: pointer;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  font-size: 1.6rem;\n  text-align: center;\n  text-decoration: none;\n  transition: all 0.3s ease;\n}", ""]);
// Exports
exports.locals = {
	"container": "auth-pages__Logout__container__2rR-3",
	"blurb": "auth-pages__Logout__blurb__3vomt",
	"link": "auth-pages__Logout__link__2pijF"
};
module.exports = exports;
